import GapSequenceWrapper from 'analyses/alignment/GapSequenceWrapper';
import BenchlingConfig from 'BenchlingConfig';
import {ComponentsSequence} from 'components/Sequence';

export function isCreateNewPartFromSelectionDisabled(
  sequence: ComponentsSequence | GapSequenceWrapper
): boolean {
  return BenchlingConfig.PARTS_ENABLE_OVERLAPPING_PARTS
    ? !sequence.allowFeatureEdits() || !sequence.canInsertPart()
    : !sequence.allowResidueEdits() || !sequence.isSelectionDeletable() || !sequence.canInsertPart();
}
